import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.span<{
  $overdue: boolean;
  $lastWeek: boolean;
  $noColor: boolean;
  $chip: boolean;
  $isCompleted: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;

  overflow: hidden;
  transition: color 200ms;

  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $chip, theme }) =>
    $chip &&
    css`
      flex-shrink: 0;
      width: auto;

      padding: ${`0 ${theme.spacing(1)}`};

      border-radius: ${theme.spacing(1.5)};
      background: ${theme.palette.grey[100]};

      color: ${theme.palette.text.secondary};
    `};

  ${({ $lastWeek, $noColor, theme }) =>
    $lastWeek &&
    !$noColor &&
    css`
      color: ${theme.palette.warning.main};
    `};

  ${({ $overdue, $noColor, theme }) =>
    $overdue &&
    !$noColor &&
    css`
      color: ${theme.palette.error.main};
    `};

  ${({ $isCompleted, theme }) =>
    $isCompleted &&
    css`
      color: ${theme.palette.text.secondary};
    `};
`;

export const IconContainer = styled.span<{ $isSmall: boolean }>`
  font-size: ${({ $isSmall }) => ($isSmall ? '1rem' : '114.3%')};
  line-height: 62.5%;
`;

export const Label = styled.span<{ $chip: boolean }>`
  ${({ $chip, theme }) =>
    $chip &&
    css`
      ${typographyToCss(theme.typography.caption)};
    `};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;
